import React, { FC } from 'react';

export interface BookmarkButtonProps {
  isBookmarked: boolean;
  onClick: () => void;
}

const BookmarkButton: FC<BookmarkButtonProps> = ({ isBookmarked, onClick }) => {
  return (
    <button
      type="button"
      className={`c-bookmark ${isBookmarked ? 'c-bookmark--active' : ''}`}
      aria-label="お気に入りに追加"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick();
      }}
    />
  );
};

export default BookmarkButton;
